export default {
  titleContent: {
    type: String,
    default: 'incluido'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/components/resources/props.js